export function getDecimalsFromContract(val: bigint | number | string): number {
  const v = typeof val === 'bigint' ? val : BigInt(val);

  if (v === 0n) throw new Error('Invalid value: 0');

  if (v < 40n) return Number(v);

  const s = v.toString();
  if (/^1(0+)$/.test(s)) return s.length - 1;

  let x = v;
  let exp = 0;
  while (x % 10n === 0n) {
    x /= 10n;
    exp++;
  }
  if (x !== 1n) {
    throw new Error(`Value ${v} is not a pure 10**decimals scale`);
  }
  return exp;
}
